import { z } from "zod";
import { ZodProjectState } from "../zod-types/zod-project-state";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const projectStateSchema = z.object({
	state: ZodProjectState,
});

export const projectSchema = z
	.object({
		name: ZodStringNullable,
		number: ZodStringNullable,
		workspaceId: z.string(),

		/** Address */
		streetName: z.string().min(1),
		houseNumber: ZodStringNullable,
		city: z.string().nonempty(),
		zipCode: z.string().min(5).max(5),
		note: ZodStringNullable,
		relatedProjectId: ZodStringNullable,
		clientId: ZodStringNullable,
		coordinates: z.any().optional(),
		/**
		 * The weekdays work may happen on at this site, Monday-first offsets. Mandatory and never
		 * empty: this is what a ticket's estimate is counted in, so a site nobody may work would
		 * leave every ticket on it undrawable.
		 */
		weekdays: z.array(z.number().int().min(0).max(6)).min(1),

		id: z.string().optional(),
	})
	.and(projectStateSchema)
	.transform((data) => {
		if (!data.name) data.name = `${data.streetName || ""} ${data.houseNumber || ""}`.trim();
		return data;
	});

export type ProjectSchemaForm = z.infer<typeof projectSchema>;
